'use strict';

import React, { Component } from 'react';

import CurveChartHighchartConsoDay from '../../../global/chart/highchart/curveChartConsoDay.jsx';
import BarChartHighchartConsoDay from '../../../global/chart/highchart/barchartConsoDay.jsx';
import Moment from 'moment';
import $ from 'jquery';

class Consommation extends Component{
     emptyList = [];
        state = {
            //Initiate Time for the chart
            timeFrom: this.props.timeFrom,
            timeTo: this.props.timeTo,
            seriesConsoDay: '{}',
            dataset: "",
            value: "", //Value of paygo box
            listBox: this.emptyList
        }
    componentDidUpdate() {
        console.log('[DEBUG],Chart Component Did Update');
    }
    componentDidMount= () => {
        //Get Data From paygo User
        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'GetList class';
        var url = "/user/paygoboxlist";
        var testTime = Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);

        this.serverRequest = $.get(url, function(result) {
            console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
            console.log(result);
            var optionTmp = [];
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.userList.length; i += 1) {
                    optionTmp.push({id: data.userList[i].name, value: data.userList[i].name})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                return;
            }
            this.setState({listBox: optionTmp});
        }.bind(this));
    }
    onChange= async (e) => {
        e.preventDefault();
        var paygoId = e.target.value;
        this.setState({value: paygoId});
        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'card class';
        var url = "/services/data/consoDay/asadmin?from=" + this.state.timeFrom + "&to=" + this.state.timeTo + "&agg=" + this.props.agg + "&info=" + this.props.sensor + "&boxId=" + paygoId;
        var testTime = Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);

        this.serverRequest = $.get(url, function(result) {
            console.log('[INFO],  reception front des données: ');
            console.log(result);
            var dtmp = [];
            var dataset = "";
            var serieNameData = [];
            try {

                var data = JSON.parse(result);
                console.log(data);

                for (var i = 0; i < data.DatapointList.length; i += 1) {
                    var datePoint = Date.parse(data.DatapointList[i].measureTime);
                    var d = new Date();
                    var offSet = d.getTimezoneOffset();

                    dtmp.push([
                        datePoint - 1000 * 60 * offSet,
                        data.DatapointList[i].value
                    ]);
                    var dateOfThePoint = datePoint - 1000 * 60 * offSet;
                    var datePointString = new Date(dateOfThePoint).toISOString();
                    dataset = dataset + datePointString + "," + data.DatapointList[i].value + "\n";
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                return;
            }
            var serietmp = [
                {
                    name: 'Consommation Jour',
                    data: dtmp
                }
            ];
            //console.log(serietmp);
            this.setState({
                seriesConsoDay: serietmp,
                dataset: "data:application/csv;charset=utf-8," + encodeURIComponent(dataset)
            });
        }.bind(this));
    }
    componentWillUnmount() {
        this.serverRequest.abort();
    }

    render() {
        console.log('[INFO], render fonction card');
        var listBox = this.state.listBox;
        listBox.sort(function(a, b) {
            if (a.value>b.value){
              return -1;
            }
            if (a.value < b.value){
              return 1;
            }
            return 0;
        });

        return (
            <div className="container">
                <div className="block-header">
                    <h2>Energy Management</h2>
                    {/*
                    <ul className="actions">
                        <li>
                            <a href="#">
                                <i className="zmdi zmdi-trending-up"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="zmdi zmdi-check-all"></i>
                            </a>
                        </li>
                        <li className="dropdown">
                            <a href="#" data-toggle="dropdown">
                                <i className="zmdi zmdi-more-vert"></i>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a href="#">Refresh</a>
                                </li>
                                <li>
                                    <a href="#">Manage Widgets</a>
                                </li>
                                <li>
                                    <a href="#">Widgets Settings</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                  */}

                </div>

                <div id="data-table-basic-header" className="bootgrid-header container-fluid">
                    <div className="row">
                        <div className="col-sm-12 actionBar">
                            <div className="search form-group">
                                <div className="input-group">
                                    <span className="zmdi icon input-group-addon glyphicon-search"></span>

                                    <select className="search-field form-control" value={this.state.value} onChange={this.onChange}>
                                        {listBox.map(function(optionval) {
                                            return <option value={optionval.id}>{optionval.value}</option>;
                                        })
}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h2>{this.props.ChartName}
                            <small>Consommation en Watt Heure</small>
                        </h2>

                        <ul className="actions">
                            {/*
                            <li>
                                <a href="#">
                                    <i className="zmdi zmdi-refresh-alt"></i>
                                </a>
                            </li>
                          */}
                            <li>
                                <a href={this.state.dataset} download="MyJouleBox-Month-Data.csv">
                                    <i className="zmdi zmdi-download"></i>
                                </a>
                            </li>
                            {/*
                            <li className="dropdown">
                                <a href="#" data-toggle="dropdown">
                                    <i className="zmdi zmdi-more-vert"></i>
                                </a>

                                <ul className="dropdown-menu dropdown-menu-right">
                                    <li>
                                        <a href="#">Change Date Range</a>
                                    </li>
                                    <li>
                                        <a href="#">Change Graph Type</a>
                                    </li>
                                    <li>
                                        <a href="#">Other Settings</a>
                                    </li>
                                </ul>
                            </li>
*/}
                        </ul>
                    </div>

                    <div className="card-body">
                        <div className="chart-edge">
                            <div id="curved-line-chart" className="bar-chart ">
                                <BarChartHighchartConsoDay graphName={this.props.graphName} container='chartAn' series={this.state.seriesConsoDay} Xaxiscategories={this.state.XaxiscategoriesAnnual}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Consommation;
